import {ref, Vue} from "vue";
import * as L from "leaflet";
import "leaflet-polylinedecorator";
import "leaflet.polylinemeasure";

export const mapControlService = {
    addControlToMap,
    addScaleControlToMap,
    addPolylineMeasurerControlToMap,
};

function addControlToMap (map, options) {
    let ctrlOptions = (options) ? options : {
        position: "topleft"
    };

    let control = L.control(ctrlOptions);
    control.addTo(map);
    return control;
};

function addScaleControlToMap(map, options) {
    let ctrlOptions = (options) ? options : {
        maxWidth: 240,
        metric: false,
        imperial: true,
        position: "bottomleft",
    };

    return L.control.scale(ctrlOptions).addTo(map);
};

function addPolylineMeasurerControlToMap(map, options) {
    let ctrlOptions = (options) ? options : {
            position: "topleft",
            unit: "landmiles",
            showBearings: true,
            clearMeasurementsOnStop: false,
            showClearControl: true,
            showUnitControl: true,
        };
    return L.control.polylineMeasure(ctrlOptions).addTo(map);
};

